// Countries supported (Australia only)
export const COUNTRIES = [
  { value: 'AU', label: 'Australia', currency: 'AUD' }
];

// Australian States/Territories
export const AUSTRALIAN_STATES = [
  { value: 'NSW', label: 'New South Wales' },
  { value: 'VIC', label: 'Victoria' },
  { value: 'QLD', label: 'Queensland' },
  { value: 'WA', label: 'Western Australia' },
  { value: 'SA', label: 'South Australia' },
  { value: 'TAS', label: 'Tasmania' },
  { value: 'ACT', label: 'Australian Capital Territory' },
  { value: 'NT', label: 'Northern Territory' }
];

// New Zealand Regions (kept for future expansion, currently unused)
export const NZ_REGIONS = [];

// Get regions by country
export const getRegionsByCountry = (countryCode) => {
  switch (countryCode) {
    case 'AU':
      return AUSTRALIAN_STATES;
    case 'NZ':
      return NZ_REGIONS;
    default:
      return AUSTRALIAN_STATES;
  }
};

// Get region name by code
export const getRegionName = (regionCode, countryCode = 'AU') => {
  const regions = getRegionsByCountry(countryCode);
  const region = regions.find(r => r.value === regionCode);
  return region?.label || regionCode;
};

// Get country name by code
export const getCountryName = (countryCode) => {
  const country = COUNTRIES.find(c => c.value === countryCode);
  return country?.label || countryCode;
};

// Get currency by country
export const getCurrencyByCountry = (countryCode) => {
  const country = COUNTRIES.find(c => c.value === countryCode);
  return country?.currency || 'AUD';
};

// Radius options (same for both countries)
export const RADIUS_OPTIONS = [
  { value: 25, label: '25 km' },
  { value: 50, label: '50 km' },
  { value: 100, label: '100 km' },
  { value: 150, label: '150 km' },
  { value: 200, label: '200 km' },
  { value: 250, label: '250 km' }
];
